module.exports = __webpack_public_path__ + "img/vc.b2f0a5ea.svg";